/**
 * User model.
 */
export default {
  fields: {
    id: 0,
    planName: '',
    products: 0,
    orders: 0,
    users: 0,
    // marketplaces: 0,
    skus: 0,
    // planId: '',
    // productId: '',
    // discount: 0,
    interval: '',
    // recurring: false,
    popular: false,
    price: 0,
    currency: '',
    enabled: true,
    account_id: [],
  },
  getDefaults() {
    return JSON.parse(JSON.stringify(this.fields));
  },
  /**
   * Returns completed fields from a response.
   * @param response
   */
  fromApiResponse(response) {
    return {
      id: response.id,
      planName: response.name,
      description: response.short_description,
      products: response.options.items,
      orders: response.options.orders,
      users: response.options.users,
      // marketplaces: response.marketplaces,
      skus: response.options.skus,
      // planId: response.plan_id,
      // productId: response.product_id,
      // discount: response.discount,
      interval: response.interval,
      // recurring: response.recurring,
      popular: response.is_popular,
      price: response.unit_amount,
      currency: response.currency,
      features: response.features.length ? response.features.join(', ') : '',
      enabled: response.is_active,
      account_id: response.accounts,
    };
  },
  /**
   * Return an object for sending to a API
   * @param modal
   */
  toApiRequest(model) {
    const data = {
      name: model.planName,
      short_description: model.description,
      interval: model.interval,
      unit_amount: +model.price,
      currency: model.currency,
      features: model.features.split(','),
      options: {
        items: +model.products,
        skus: +model.skus,
        users: +model.users,
        orders: +model.orders,
      },
      // features: [
      //   500 orders per month
      // ],
      is_active: model.enabled,
      is_default: model.is_default,
      is_popular: model.popular,
      account_id: model.account_id,
      // plan_name: model.planName,
      // orders: model.orders,
      // users: model.users,
      // marketplaces: model.marketplaces,
      // skus: model.skus,
      // plan_id: model.planId,
      // product_id: model.productId,
      // discount: model.discount,
      // interval: model.interval,
      // recurring: model.recurring,
      // popular: model.popular,
      // price: model.price,
      // currency: model.currency,
      // is_active: model.enabled,
    };

    return data;
  },
};
